











































import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

interface EventDetails {
  date: string;
  function: string;
  description: string;
}

@Component
export default class YearPlan extends Vue {
  yearplan:object = []
  count:number = 0

  mounted () {
    axios.get('/json/yearplan.json').then(
      response => {
        var temp = response.data

        Object.entries(temp).forEach(
          ([ year, events]: any) => {
            events = events.map(
              (e: any, i: any) => {
                if (i > 0) {
                  var g = events[i - 1]
                  if (e['date'] !== g['date']) { e['inverted'] = !g['inverted'] } else { e['inverted'] = g['inverted'] }
                } else { e['inverted'] = false }
                e['order'] = this.count
                this.count++
              }
            )
          }
        )

        this.yearplan = temp
      }
    )
  }
}
